import { apiUrl } from "helpers/constants/config.constants";
import { httpGet, httpPatch, httpPost } from "./http.service";
import { AxiosResponse } from "axios";
import { Product } from "./product.service";
import { User } from "./user.service";
import { CustomerModel } from "./customer.service";
import { FileObject } from "./file.service";

export interface Order {
  orderId: string
  orderCode: string
  projectId: string
  userId: string
  customerId: string
  total: number
  totalDiscount: number
  totalFee: number
  remark: string
  status: string
  orderDetails: OrderDetail[]
  displayProduct: Product
  deliveryAddress: string
  deliveryMethod: string
  deliveryDate: Date
  createdAt: Date
  user: User
  customer: CustomerModel
}

export interface OrderDetail {
  orderDetailId: string
  orderId: string
  product: Product
  quantity: number
  subtotal: number
}

export interface OrderCustom {
  orderCustomId: string
  orderCode: string
  projectId: string
  customerId: string
  image: string
  files: FileObject[]
  description: string
  quantity: number
  subtotal: number
  status: string
  displayProduct: Product
  deliveryAddress: string
  deliveryMethod: string
  deliveryDate: Date
  createdAt: Date
  customer: CustomerModel
}

export const doListOrder = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.order.list, { skip }).then((resp) => {
      const response = resp as AxiosResponse
      resolve(response.data);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doGetOrderDetail = (orderId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.order.get(orderId)).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doCreateOrder = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.order.create, params).then((response) => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const doUpdateOrder = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.order.update(params.orderId as string), { ...params }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doUpdateOrderStatus = (orderId: string, status: string) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.order.updateStatus(orderId), { status }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doGetOrderStatus = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.setting.listStatus).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export const doListCustomOrder = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.customOrder.list, { skip }).then((resp) => {
      const response = resp as AxiosResponse
      resolve(response.data);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doGetCustomOrderDetail = (orderId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.customOrder.get(orderId)).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doCreateCustomOrder = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.customOrder.create, params).then((response) => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const doUpdateCustomOrder = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.customOrder.update(params.orderCustomId as string), { ...params }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}

export const doUpdateCustomOrderStatus = (orderId: string, status: string) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.customOrder.updateStatus(orderId), { status }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}